import type { VoidFunctionComponent } from 'react';
import styles from '../ReleaseGroupsRevamp.module.less';
import type { PortalTokenSettingsProps } from '../../../components/ProjectGroupPortalSettings';
import ProjectGroupTokenSettings from '../../../components/ProjectGroupPortalSettings';

/**
 * Render the portal settings section with the section style applied.
 */
const PortalSettings: VoidFunctionComponent<PortalTokenSettingsProps> = (props) => {
  return (
    <div className={styles.section}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ProjectGroupTokenSettings {...props} />
    </div>
  );
};

export default PortalSettings;
